import { FacadeDetailPhotoRemarksDto } from "./facadeDetailPhotoRemarks.model";

export class ChangeOutsideSurveyPhotoRemarksDto {
  surveyId: string;
  facadePhotoRemarks: string;
  facadeDetailPhotoRemarks: FacadeDetailPhotoRemarksDto[];

  constructor(
    surveyId: string,
    facadePhotoRemarks: string,
    facadeDetailPhotoRemarks: FacadeDetailPhotoRemarksDto[]
  ) {
    this.surveyId = surveyId;
    this.facadePhotoRemarks = facadePhotoRemarks;
    this.facadeDetailPhotoRemarks = facadeDetailPhotoRemarks;
  }
}
